'use strict';

/**
 * Complex Legend Directive
 * @constructor
 */
var ComplexLegendDirective = function ComplexLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/complex-legend.html'),
    /**
     * @param {Object} scope
     * @param {ChartLegendItemDirective.scope.item[]} scope.legend - array of legend items
     * @param {string} [scope.legendTitle] - legend's title
     * @param {ChartLegendItemDirective.scope.item[]} [scope.staticLegend] - array of static legend items (ex. No Data)
     * @param {string} [scope.collapsible] - should legend be collapsible. If value other than 'true', will be false
     * @param {string} [scope.elementWidth] - element width (icon + name)
     * @param {string} [scope.itemMaxLength] - max number of letters in legend item, excess is truncated
     * @param {string} [scope.rowSize] - number of item in row
     */
    scope: {
      legend: '=',
      legendTitle: '=',
      staticLegend: '=',
      collapsible: '@',
      elementWidth: '=',
      itemMaxLength: '=',
      rowSize: '='
    },
    link: function link(scope, element) {
      var defaultElementWidth = 190;
      var panelContent = element.find('.legend-wrap');
      var panelContentHeight;
      var legendItemHeight = 20;
      var itemsMainPadding = 10;
      var titleElement = element.find('.legend-header');
      scope.rowSize = scope.rowSize ? scope.rowSize : 4;
      function getCollapseHeight() {
        return Math.floor(legendItemHeight + 2 * itemsMainPadding) - panelContentHeight;
      }
      scope.initLegend = function () {
        scope.displayWidth = scope.elementWidth || defaultElementWidth;
        var titleHeight = titleElement.outerHeight() || 0;
        var rows = Math.ceil(scope.legend.length / scope.rowSize);
        if (rows === 1) {
          scope.displayRowSize = scope.legend.length;
          scope.displayCollapsible = false;
        } else {
          scope.displayRowSize = scope.rowSize;
          scope.displayCollapsible = scope.collapsible === 'true';
        }
        if (scope.displayCollapsible) {
          panelContentHeight = rows * (legendItemHeight + itemsMainPadding) + itemsMainPadding + titleHeight + 1;
          scope.legendIsCollapsed = false;
          scope.togglePanel();
        } else {
          panelContent.css('transform', 'translateY(0)');
        }
      };
      scope.togglePanel = function () {
        var height = scope.legendIsCollapsed ? 0 : getCollapseHeight() + 'px';
        panelContent.css('transform', 'translateY(' + height + ')');
        scope.legendIsCollapsed = !scope.legendIsCollapsed;
      };
      scope.$watch('legend', function (newVal, oldVal) {
        if (newVal !== oldVal && scope.legend) {
          scope.initLegend();
        }
      });
      scope.$on('trigger-tooltip:show', function (event, data) {
        scope.$broadcast('legend-tooltip-show:show', data);
      });
      scope.$on('trigger-tooltip:hide', function () {
        scope.$broadcast('legend-tooltip-show:hide');
      });
      scope.localMarketChangeHandler = function () {
        scope.marketChangeHandler(scope.selectedMarket);
      };
      if (scope.legend) {
        scope.initLegend();
      }
    }
  };
};
ComplexLegendDirective.$inject = [];
module.exports = ComplexLegendDirective;